import api from './api';

export interface FilePresignedDto {
  file: File;
  destinationUrl: string;
  signedUrl: string;
  expiration: number;
}

export interface UploadFileResult {
  file: File;
  request: XMLHttpRequest;
  isError?: boolean;
  presignedResult?: FilePresignedDto;
}

interface UploadOptions {
  presignBody: any;
}

export class UploadFile {
  loading = false;
  progress = 0;

  constructor(private readonly presignEndPoint: string) {}

  async presignUrl(
    file: File,
    options?: UploadOptions
  ): Promise<FilePresignedDto> {
    const { presignBody = {} } = options || {};
    this.loading = true;
    const result = await api.post(this.presignEndPoint, {
      mimeType: file.type,
      ...presignBody
    }).response;
    this.loading = false;
    return result.json();
  }

  async upload(file: File, options?: UploadOptions) {
    const presignedResult = await this.presignUrl(file, options);
    if (!presignedResult) {
      console.error('Presign failed');
      return;
    }
    const request = new XMLHttpRequest();
    const uploadingFile: UploadFileResult = {
      file,
      request,
      presignedResult
    };
    return new Promise<UploadFileResult>((resolve, reject) => {
      request.upload.addEventListener('progress', event => {
        this.progress = event.loaded / event.total;
      });
      request.addEventListener('load', () => {
        this.progress = 1;
        // console.log('uploadFile load completed');
        resolve(uploadingFile);
      });
      request.addEventListener('error', event => {
        this.progress = 0;
        uploadingFile.isError = true;
        // console.log('uploadFile error');
        reject(event);
      });

      request.open('PUT', presignedResult.signedUrl);
      request.setRequestHeader('Content-Type', file.type);
      request.responseType = 'text';
      request.send(file);
    });
  }
}
